import { h } from "preact";

import RawColor from "../../../foundation/api/model/colors/RawColor";
import { TagGroupTypes } from "../../../foundation/enums";
import Color from "../../../foundation/model/color";
import classname from "../../../foundation/utils/classname";
import { getMarkerCSSVariableForApiColor } from "../../../foundation/utils/color";

import { DEFAULT_COLORS } from "../ColorDotSelector/ColorDotSelector";

import styles from "./TagTypeIndicator.module.css";

type Props = {
    tagGroupType?: TagGroupTypes;
    color?: RawColor;
};

export default function TagTypeIndicator({ tagGroupType, color }: Props) {
    const colorValue = color ? new Color(color) : DEFAULT_COLORS[0];

    const colorCSS = getMarkerCSSVariableForApiColor(colorValue) ?? colorValue.toRGBAString();

    switch (tagGroupType) {
        case TagGroupTypes.status:
            return (
                <span
                    style={
                        { backgroundColor: colorCSS }
                    }
                    class={styles.statusIndicator}/>
            );
        case TagGroupTypes.member:
            return <span class={classname(styles.memberIndicator, "body-1")}>@</span>;
        default:
            return null;
    }
}
